import React from 'react';

import { ProductFiltersController } from '../../hooks/useProductFilters';
import {
  TrackAllFiltersCleared,
  TrackFilterCleared,
} from '../../utils/analytics';
import { FilterBadge } from './FilterBadge';
import FilterBar from './FilterBar';

type Props = {
  className?: string;
  filters: ProductFiltersController;
};

const ProductFiltersBar: React.FC<Props> = ({ className, filters }) => {
  return (
    <FilterBar
      className={className}
      onClear={() => {
        filters.clearAll();

        TrackAllFiltersCleared({
          page: 'works index',
          location: 'filter bar',
        });
      }}
    >
      {filters.mediums.values.map((value) => (
        <FilterBadge
          key={value}
          label={value}
          onRemove={() => {
            filters.mediums.remove(value);
            TrackFilterCleared({
              page: 'works index',
              filterLabel: value,
            });
          }}
        />
      ))}

      {filters.finish.values.map((value) => (
        <FilterBadge
          key={value}
          label={value}
          onRemove={() => {
            filters.finish.remove(value);
            TrackFilterCleared({
              page: 'works index',
              filterLabel: value,
            });
          }}
        />
      ))}

      {filters.release.values.map((value) => (
        <FilterBadge
          key={value}
          label={value}
          onRemove={() => {
            filters.release.remove(value);
            TrackFilterCleared({
              page: 'works index',
              filterLabel: value,
            });
          }}
        />
      ))}
    </FilterBar>
  );
};

export default ProductFiltersBar;
